import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductPageContext } from "../context/ProductPageContext"

export const ProductPageDimensionButton = React.memo(() => {
  const { t } = useTranslation()
  const { onDimension } = useProductPageContext()

  return (
    <Button
      id="product-page__dimensioning-button"
      variant={ButtonVariant.SECONDARY}
      disabled={!onDimension}
      onClick={onDimension}
      icon={IconName.DIMENSIONING}
    >
      {t("Product.Configuration.Dimension")}
    </Button>
  )
})
